import $ from "jquery"

$('.js-single-main-view').on('click', function(){
    $(this).toggleClass('sidebar-box__btn--walk sidebar-box__btn--map').text('Rzut mieszkania');
    $('.sidebar-box__btn--walk').text('widok 3d');
    $('.js-default-image, .js-default-walk').toggleClass('d-none');
});

window.addEventListener('DOMContentLoaded', (event) => {
    var iframe = document.querySelector('.walk-listing iframe'); // select your iframe
    if (iframe) {
        iframe.onload = function() {
            setTimeout(() => {
                try {
                    var body = iframe.contentWindow.document.body;
                    var html = iframe.contentWindow.document.documentElement;
                    var height = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
                    iframe.style.height = height + 'px';
                } catch (e) {
                    console.log(e);
                }
            }, 0);
        }
    }
});
